export const SUBURBS = [
  { name: "Fremantle", slug: "fremantle" },
  { name: "Joondalup", slug: "joondalup" },
  { name: "Rockingham", slug: "rockingham" },
  { name: "Mandurah", slug: "mandurah" },
  { name: "Baldivis", slug: "baldivis" },
  { name: "Canning Vale", slug: "canning-vale" },
  { name: "Ellenbrook", slug: "ellenbrook" },
  { name: "Morley", slug: "morley" },
  { name: "Midland", slug: "midland" },
  { name: "Armadale", slug: "armadale" },
  { name: "Scarborough", slug: "scarborough" },
  { name: "Subiaco", slug: "subiaco" },
  { name: "South Perth", slug: "south-perth" },
  { name: "Victoria Park", slug: "victoria-park" },
  { name: "Belmont", slug: "belmont" },
  { name: "Cannington", slug: "cannington" },
  { name: "Wanneroo", slug: "wanneroo" },
  { name: "Osborne Park", slug: "osborne-park" },
  { name: "Cockburn", slug: "cockburn" },
  { name: "Duncraig", slug: "duncraig" },
  { name: "Karrinyup", slug: "karrinyup" },
  { name: "Applecross", slug: "applecross" },
  { name: "Booragoon", slug: "booragoon" },
  { name: "Thornlie", slug: "thornlie" },
  { name: "Gosnells", slug: "gosnells" },
  { name: "Bayswater", slug: "bayswater" },
  { name: "Bassendean", slug: "bassendean" },
  { name: "Hillarys", slug: "hillarys" },
  { name: "Clarkson", slug: "clarkson" },
  { name: "Butler", slug: "butler" },
  { name: "Kalamunda", slug: "kalamunda" },
  { name: "Yanchep", slug: "yanchep" },
];

export const suburbPath = (s) => `/hot-water-systems-${s.slug}`;

export const findSuburbBySlug = (routeSlug) =>
  SUBURBS.find((s) => `hot-water-systems-${s.slug}` === routeSlug) || null;
